import {Moment} from 'moment-timezone'

import {getHistoryAssetsById} from '../selectors'

import {useAssetsHistoryQuery, type MomentRange} from './useAssetsHistoryQuery'

interface UseHistoryAssetsByIdQueryParams {
  plantId: string
  timeFrame: MomentRange
  date?: Moment
  throwOnError?: boolean
}

export const useHistoryAssetsByIdQuery = ({
  plantId,
  timeFrame,
  date,
  throwOnError = true
}: UseHistoryAssetsByIdQueryParams) => {
  const [, endOfPlan] = timeFrame
  return useAssetsHistoryQuery({
    plantId,
    timeFrame,
    throwOnError,
    select: (assetsHistory) => {
      return getHistoryAssetsById(assetsHistory, date ?? endOfPlan)
    }
  })
}
